$(document).ready(function($) {

    $(".js-open-vacature-form").click( function() {
        $('.js-vacature-scroll-to')[0].scrollIntoView({behavior: "smooth"});
    });
});